export default __webpack_public_path__ + "static/media/pic1.14055d81.png";